// extracted by mini-css-extract-plugin
export default {"main":"Loader_main__DZjgG"};